document.addEventListener('DOMContentLoaded', function() {
    toggleActiveTags();

    function toggleActiveTags() {
        let tags = document.querySelectorAll('.tags .tag');

        tags.forEach((tag, i) => {
            tag.addEventListener('click', function() {
                // remove a tag ativa caso clicada uma segunda vez e retorna para 'todas'
                if ( i !== 0 && this.classList.contains('active') ) {
                    tags.forEach(t => t.classList.remove('active'));
                    tags[0].classList.add('active');
                } else {
                    tags.forEach(t => t.classList.remove('active'));
                    this.classList.add('active');
                }
            })
        })
    }
})